<ion-content class="login-content" [fullscreen]="true">
  <div class="amplify-authenticator">
    <amplify-authenticator [loginMechanisms]="['email']" [hideSignUp]="true"></amplify-authenticator>
  </div>
</ion-content>

<ion-footer class="main-footer ion-padding">
  <div class="version-container">
    <ion-text color="dark">Nwave <ion-img [src]="logoSrc" class="logo"></ion-img> SPlace {{appVersion}}</ion-text>
  </div>
</ion-footer>
  